export default class Dadata {
  public static async suggestAddress(data: { query: string }) {
    const options = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + "bdfe1bcf30e371b56f5e4b09b3bde3857c02baff",
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(
      "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address",
      options
    );

    const result = await response.json();
    return result;
  }

  public static async suggestCompany(data: { query: string }) {
    const options = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + "bdfe1bcf30e371b56f5e4b09b3bde3857c02baff",
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(
      "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party",
      options
    );

    const result = await response.json();
    return result;
  }

  public static async ipAddress() {
    const options = {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + "bdfe1bcf30e371b56f5e4b09b3bde3857c02baff",
      },
    };

    const response = await fetch(
      "https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address",
      options
    );

    const result = await response.json();
    return result;
  }
}
